:host {
  display: block;
  max-width: 100%;
}

.title-custom-align {
  padding-bottom: 13px;
}

gz-selected-list-item {
  border-top: 1px solid var(--chart-100-pressed);

  &:last-child {
    border-bottom: 1px solid var(--chart-100-pressed);
  }
}

gz-text[class='empty'] {
  display: flex;
  align-items: center;
  height: 32px;
  color: var(--grey-layout-200-disabled);
}
